import { DEFAULT_THEME } from "conversion_flows/shared/contexts/dealerTheme"
import React from "react"

type TradeInTheme = {
  color: string
  textCtaColor?: string
}

const TradeInThemeContext = React.createContext<TradeInTheme>({
  color: DEFAULT_THEME.brandPrimary,
})
export const TradeInThemeProvider = TradeInThemeContext.Provider
export default TradeInThemeContext
